
import {Component, Vue} from "vue-property-decorator";
import CompanySmsOptions from "@/components/company/CompanySmsOptions.vue";
import {Getter} from "vuex-class";

@Component({
  components: {
    CompanySmsOptions,
  },
})
export default class SmsOptions extends Vue {
    @Getter private currentUser: any;
    @Getter private envCompanyId: number|null;
}
